import {DocumentNode} from 'graphql';
import gql from 'graphql-tag';

import {doQuerySafe} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {
  TagSchemaInterfacesQuery,
  TagSchemaInterfacesQueryVariables,
} from 'schemas/util/__generated/TagSchemaInterfacesQuery';

// Queries visible for tests
export const TAG_SCHEMA_INTERFACES_QUERY: DocumentNode = gql`
  query TagSchemaInterfacesQuery($id: StrictString!) @skipAudit @engComponent(name: SCHEMAS) {
    tagSchema(id: $id) {
      ...TagSchemaInterfacesGraphQL
      ... on InaccessibleInfoNode {
        invalidId
      }
    }
  }
  ${getFragmentWrapper('TagSchemaInterfaces').fragment}
`;

/**
 * Returns the IDs of the schema interfaces that a tag schema implements, or an empty set if the schema is
 * inaccessible. Results are served from the Apollo cache when available.
 *
 * Query failures are propagated so that each caller can decide whether to block or fall back.
 */
export default async function getTagSchemaInterfaceIds(
  tagSchemaId: StrictString
): Promise<ReadonlySet<string>> {
  const result = await doQuerySafe<TagSchemaInterfacesQuery, TagSchemaInterfacesQueryVariables>(
    {query: TAG_SCHEMA_INTERFACES_QUERY},
    {variables: {id: tagSchemaId}, fetchPolicy: 'cache-first'}
  );
  if (result.tagSchema.__typename !== 'TagSchemaNode') {
    return new Set();
  }
  return new Set(result.tagSchema.interfaces.map((schemaInterface) => schemaInterface.id));
}
